/* eslint-disable arrow-body-style */
import { getGameWeight, IGameWeightConfig } from './_constants';

/**
 * 游戏数据接口
 */
export interface IGameData {
  game_code: string;
  game_name?: string;
  game_cn_name?: string;
  game_List?: IGameData[];
  [key: string]: any;
}

/**
 * 计算游戏权重
 * @param game - 游戏数据
 * @param weights - 权重配置
 * @returns 权重值
 */
const calculateGameWeight = (game: IGameData, weights?: IGameWeightConfig): number => {
  return weights?.[game?.game_code] ?? getGameWeight(game?.game_code);
};


/**
 * 根据权重对游戏列表进行排序
 * @param games - 游戏列表
 * @param weights - 权重配置
 * @returns 排序后的新数组
 */
export const sortGames = (
  games: IGameData[],
  weights?: IGameWeightConfig
): IGameData[] => {
  // 只对第一层进行排序，不递归处理子游戏列表
  return [...games].sort((a, b) => {
    const weightA = calculateGameWeight(a, weights);
    const weightB = calculateGameWeight(b, weights);
    return weightB - weightA; // 降序：权重高的在前
  });
};
